import {createRouter, createWebHistory} from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'AdminLayout',
    component: () => import('../components/EmptyLayout.vue'),
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Login.vue')
      },
      {
        path: '',
        name: 'Layout',
        component: () => import('../components/Layout.vue'),
        children: [
          {
            path: 'scenic_spots',
            name: 'ScenicSpotsLayout',
            component: () => import('../views/Admin/ScenicSports/Container.vue'),
            children: [
              {
                path: '',
                name: 'ScenicSpots',
                component: () => import('../views/Admin/ScenicSports/Index.vue')
              },
              {
                path: 'new',
                name: 'NewScenicSpots',
                component: () => import('../views/Admin/ScenicSports/New.vue')
              },
              {
                path: ':id/edit',
                name: 'EditScenicSpots',
                component: () => import('../views/Admin/ScenicSports/Edit.vue')
              },
            ]
          },
          // hotel
          {
            path: 'hotels',
            name: 'HotelsLayout',
            component: () => import('../views/Admin/Hotels/Container.vue'),
            children: [
              {
                path: '',
                name: 'Hotels',
                component: () => import('../views/Admin/Hotels/Index.vue')
              },
              {
                path: 'new',
                name: 'NewHotel',
                component: () => import('../views/Admin/Hotels/New.vue')
              },
              {
                path: ':id/edit',
                name: 'EditHotel',
                component: () => import('../views/Admin/Hotels/Edit.vue')
              }
            ]
          },
          // card
          {
            path: 'cards',
            name: 'CardsLayout',
            component: () => import('../views/Admin/Cards/Container.vue'),
            children: [
              {
                path: '',
                name: 'Cards',
                component: () => import('../views/Admin/Cards/Index.vue')
              },
              {
                path: 'new',
                name: 'NewCards',
                component: () => import('../views/Admin/Cards/New.vue')
              },
            ]
          },
          {
            path: 'operators',
            name: 'Operators',
            component: () => import('../views/Admin/Operators/index.vue')
          }
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
